export const languagesCz = {
  languages: {
    // Primary/Common European languages (sort_order 1-20)
    'en': 'Angličtina',
    'sk': 'Slovenština',
    'cs': 'Čeština',
    'de': 'Němčina',
    'da': 'Dánština',
    'es': 'Španělština',
    'fr': 'Francouzština',
    'it': 'Italština',
    'pl': 'Polština',
    'hu': 'Maďarština',
    'ro': 'Rumunština',
    'nl': 'Holandština',
    'pt': 'Portugalština',
    'ru': 'Ruština',
    'uk': 'Ukrajinština',
    'el': 'Řečtina',
    'bg': 'Bulharština',
    'hr': 'Chorvatština',
    'sl': 'Slovinština',
    'sv': 'Švédština',
    'lv': 'Lotyština',

    // Other European languages (sort_order 21-30)
    'lt': 'Litevština',
    'et': 'Estonština',
    'fi': 'Finština',
    'ga': 'Irština',
    'mt': 'Maltština',

    // Major Asian languages (sort_order 31-50)
    'zh': 'Mandarínská čínština',
    'hi': 'Hindština',
    'bn': 'Bengálština',
    'ja': 'Japončtina',
    'ko': 'Korejština',
    'vi': 'Vietnamština',
    'th': 'Thajština',
    'tr': 'Turečtina',
    'id': 'Indonéština',
    'ms': 'Malajština',
    'tl': 'Tagalog',
    'my': 'Barmština',
    'km': 'Khmérština',
    'ne': 'Nepálština',

    // Indian languages (sort_order 51-70)
    'te': 'Telugština',
    'mr': 'Maráthština',
    'ta': 'Tamilština',
    'gu': 'Gudžarátština',
    'kn': 'Kannadština',
    'ml': 'Malajálamština',
    'or': 'Uríjština',
    'pa': 'Paňdžábština',
    'as': 'Ásámština',
    'mai': 'Maithilština',
    'mag': 'Magahština',
    'hne': 'Čhattísgarhština',
    'bho': 'Bhódžpurština',
    'ur': 'Urdština',
    'sd': 'Sindhština',
    'skr': 'Saraíkština',
    'si': 'Sinhálština',

    // Chinese dialects/variants (sort_order 71-80)
    'wuu': 'Čínština Wu',
    'yue': 'Čínština Yue',
    'nan': 'Jižní Mincština',
    'hak': 'Hakkština',
    'cjy': 'Čínština Jin',
    'hsn': 'Čínština Xiang',
    'gan': 'Čínština Gan',
    'mnp': 'Severní Mincština',

    // Arabic dialects (sort_order 81-95)
    'arz': 'Egyptská arabština',
    'apc': 'Levantská arabština',
    'acm': 'Mezopotámská arabština',
    'acq': 'Taʽizzi-adenská arabština',
    'ayl': 'Sanaanská hovorová arabština',
    'acw': 'Hejázská arabština',
    'aeb': 'Tuniská arabština',
    'arq': 'Alžírská arabština',
    'ary': 'Marocká arabština',
    'apd': 'Súdánská arabština',
    'aec': 'Saʽidská arabština',

    // Other languages (sort_order 96+)
    'jv': 'Jávština',
    'ceb': 'Cebuánština',
    'su': 'Sundština',
    'fa': 'Perština (íránská)',
    'ps': 'Paštština (severní)',
    'pbt': 'Paštština (jižní)',
    'ku': 'Kurdština (severní)',
    'uz': 'Uzbečtina (severní)',
    'kk': 'Kazaština',
    'ug': 'Ujgurština',
    'azb': 'Jižní ázerbájdžánština',
    'ha': 'Hauština',
    'yo': 'Jorubština',
    'ig': 'Igboština',
    'fuv': 'Nigerijská fulbština',
    'am': 'Amharština',
    'so': 'Somálština',
    'rw': 'Rwandština',
    'rn': 'Rundština',
    'zu': 'Zuluština',
    'ctg': 'Čittagongština',
    'syl': 'Sylhetština',
    'dcc': 'Dakkánština',
    'rom': 'Romština'
  }
};
